import { en } from './locales/en';

type Translations = Record<string, string>;
const locales: Record<string, Translations> = { en };

let current = 'en';

export function normalizeLocaleCode(locale: string | null | undefined): string {
  const raw = String(locale ?? '').trim().toLowerCase().replace('_', '-');
  if (!raw) return 'en';
  if (raw in locales) return raw;
  const base = raw.split('-')[0] || '';
  return base in locales ? base : 'en';
}

export function setLocale(locale: string) {
  current = normalizeLocaleCode(locale);
}

export function getLocale() { return current; }

export function registerLocale(code: string, translations: Translations) {
  locales[code] = translations;
}

/** Resolve string from per-locale object or flat string. Used for subscribe title/subtitle/cta etc. */
export function resolveLocalizedString(val: string | Record<string, string> | undefined, fallback: string): string {
  if (!val) return fallback;
  if (typeof val === 'string') return val || fallback;
  const loc = getLocale();
  return val[loc] ?? val.en ?? Object.values(val)[0] ?? fallback;
}

export function t(key: string, paramsOrFallback?: Record<string, string | number> | string): string {
  const fallback = typeof paramsOrFallback === 'string' ? paramsOrFallback : undefined;
  const params = typeof paramsOrFallback === 'object' && paramsOrFallback !== null ? paramsOrFallback : undefined;
  let str = locales[current]?.[key] ?? locales.en?.[key] ?? (fallback ?? key);
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      str = str.replace(`{${k}}`, String(v));
    }
  }
  return str;
}
